export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgVisbility = require("../assets/visibility.svg");
export const imgVisbilityOff = require("../assets/visibilityOff.svg");
export const closeImage=require('../assets/ImageClose.png')
export const bsLogo =require('../assets/image_logo.png')
export const sideLoginImage=require('../assets/loginGroup.png')
export const mobileBGimage=require('../assets/group1.png')
